// ===============================
// Livraison gratuite à domicile dès 56€
// - Barre visible tant que panier non vide
// - < 56€ : "Plus que X€..." + barre progressive
// - >= 56€ : "Livraison offerte" + barre 100%
// ===============================

const FREE_SHIPPING_THRESHOLD_CENTS = 5600;

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + '€';
}

async function fetchCart() {
  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error('cart fetch failed');
  return res.json();
}

function updateUI(cart) {
  const wrap = document.querySelector('[data-free-shipping]');
  const msg = document.querySelector('[data-free-shipping-message]');
  const fill = document.querySelector('[data-free-shipping-fill]');
  const caption = document.querySelector('[data-free-shipping-caption]');
  const bar = wrap?.querySelector('.free-shipping-bar');

  if (!wrap || !msg || !fill || !caption) return;

  // Panier vide => caché
  if (cart.item_count === 0) {
    wrap.style.display = 'none';
    fill.style.width = '0%';
    if (bar) bar.setAttribute('aria-valuenow', '0');
    return;
  }

  // Panier non vide => affiché
  wrap.style.display = '';

  const remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;

  if (remaining > 0) {
    // < 56€
    msg.textContent = `🚚 Plus que ${formatMoney(remaining)} pour obtenir la livraison gratuite à domicile`;
    const progress = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
    fill.style.width = `${progress}%`;
    caption.textContent = `${formatMoney(cart.total_price)} / ${formatMoney(FREE_SHIPPING_THRESHOLD_CENTS)}`;
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(progress)));
  } else {
    // >= 56€
    msg.textContent = '🎉 Livraison gratuite à domicile offerte';
    fill.style.width = '100%';
    caption.textContent = `${formatMoney(cart.total_price)} — Livraison offerte`;
    if (bar) bar.setAttribute('aria-valuenow', '100');
  }
}

async function refresh() {
  try {
    const cart = await fetchCart();
    updateUI(cart);
  } catch (e) {
    // silence
  }
}

// 1) au chargement
document.addEventListener('DOMContentLoaded', refresh);

// 2) à l’ouverture du panier (Horizon: on:click="/open")
document.addEventListener('click', (e) => {
  if (e.target.closest('button[on\\:click="/open"]')) {
    setTimeout(refresh, 250);
  }
});

// 3) après modif panier (quantité/suppression/ajout) : on intercepte les appels Shopify
(function patchFetch() {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && /\/cart\/(add|change|update)\.js/.test(url)) {
        setTimeout(refresh, 200);
      }
    } catch (_) {}

    return res;
  };
})();
